module.exports = __webpack_public_path__ + "media/images/webpage/shared/spotmap/location__restaurant--active-69ca4a83e2fd1f138e6aa0e1511b14e8.svg";